<template>
  <div class="text-center">
    <v-menu v-model="menu" offset-y :open-on-hover="false" :bottom="true" :left="true">
      <template v-slot:activator="{ on }">
        <a class="select-header" v-on="on">
          {{ groupName }}
          <v-icon class="select-arrow" color="#ffffff" :class="menu ? 'select-arrow-active' : ''">{{ iconDown }}</v-icon>
        </a>
      </template>

      <v-list>
        <v-list-item v-for="(item, index) in options" :key="index" @click="navigatePush(item.path)">
          <v-list-item-title>{{ item.name }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
export default {
  props: {
    groupName: {
      type: String,
      default: ''
    },
    options: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      menu: false,
      iconUp: 'mdi-chevron-up',
      iconDown: 'mdi-chevron-down'
    };
  }
};
</script>

<style lang="stylus" scoped>
.select-header {
  color: #ffffff;
  font-size: 0.85rem;
  margin-right: calc(var(--gap) * 0.5);
  text-decoration: none;
  padding: 20px 5px 20px 10px;

  .v-icon.select-arrow {
    font-size: 18px;
    &-active {
      transform: rotate(180deg);
      transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), visibility 0s;
    }
  }
}
.v-menu__content {
  contain: unset;
  overflow-x: visible;
  overflow-y: visible;
}
.v-list {
  &-item {
    min-height: 35px;
    div {
      font-size: 0.85rem;
    }
  }
  &::after {
    position: absolute;
    content: "";
    display: block;
    transform: rotate(-45deg);
    border-top: 6px solid #fff;
    border-right: 6px solid #fff;
    border-left: 6px solid transparent;
    border-bottom: 6px solid transparent;
    top: -6px;
    right: 20px;
  }
}
</style>
